var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShoppingBag = function SvgShoppingBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M10.185 13.723h19.949a3.53 3.53 0 0 1 2.67 1.22 3.5 3.5 0 0 1 .808 2.812L31.404 32.02a5.24 5.24 0 0 1-1.78 3.187 5.3 5.3 0 0 1-3.438 1.265H14.13c-1.26 0-2.48-.449-3.436-1.266a5.24 5.24 0 0 1-1.78-3.186L6.707 17.754a3.48 3.48 0 0 1 .808-2.81 3.52 3.52 0 0 1 2.67-1.221"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M14.88 18.972v-8.75c0-1.392.557-2.727 1.547-3.712a5.3 5.3 0 0 1 3.732-1.537c1.4 0 2.742.553 3.732 1.537a5.24 5.24 0 0 1 1.545 3.713v8.75"
  })));
};
export default SvgShoppingBag;